export const Spinkit = {
  skChasingDots: 'sk-chasing-dots',
  skCubeGrid: 'sk-cube-grid',
  skDoubleBounce: 'sk-double-bounce',
  skRotatingPlane: 'sk-rotationg-plane',
  skSpinnerPulse: 'sk-spinner-pulse',
  skThreeBounce: 'sk-three-bounce',
  skWanderingCubes: 'sk-wandering-cubes',
  skWave: 'sk-wave',
  skLine: 'sk-line-material'
};



// WEBPACK FOOTER //
// ./src/app/shared/spinner/spinkits.ts